{
  "one": "Площадка",
  "loading": "Загружаем площадки…",
  "add": "Добавить площадку",
  "addFirst": "Добавить первую площадку",
  "emptyTitle": "Площадок пока нет",
  "emptyHint": "Площадка — это физическая локация со своим сетевым сегментом. С неё начинается карта сети и на неё устанавливается агент.",
  "loadFailed": "Не удалось загрузить площадки",
  "loadFailedHint": "{{reason}} Проверьте связь с сервером и повторите.",
  "editAria": "Изменить площадку {{name}}",
  "editTitle": "Изменить название и описание",
  "deleteAria": "Удалить площадку {{name}}",
  "deleteTitle": "Удалить площадку",
  "deleteConfirm": "Удалить площадку «{{name}}»?",
  "column": {
    "name": "Площадка",
    "description": "Описание",
    "createdAt": "Создана",
    "actions": "Действия"
  },
  "form": {
    "name": "Название",
    "namePlaceholder": "Склад на Ленина",
    "description": "Описание",
    "optional": "необязательно",
    "saving": "Сохраняем…",
    "creating": "Создаём…",
    "create": "Создать"
  }
}
